import { render, staticRenderFns } from "./TasksTags.vue?vue&type=template&id=6c855024&"
import script from "./TasksTags.vue?vue&type=script&lang=js&"
export * from "./TasksTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports